import BlokurLogoWhiteAndBlue from 'images/blokur-logo-whiteandblue.svg';
import BlokurLogoWhiteAndBlueBeta from 'images/blokur-logo-whiteandblue-beta.png';
import BlokurLogoWhite from 'images/blokur-logo-white.svg';
import BlokurLogoBlack from 'images/blokur-logo-black.png';
import MLCLogoBlue from 'images/mlc-logo-blue.png';
import Processing from 'images/processing.gif';
import DefaultDisplayPicture from 'images/default-display-picture.png';
import MaintenanceLogo from 'images/maintenance-logo.svg';
import MatchingFilterThird from 'images/matching-filter-third.png';
import PerformanceFilter from 'images/performance-filter.png';
import ProgressFilter from 'images/progress-filter.png';
import HighValueSign from 'images/icons/high-value-sign.svg';
import MediumValueSign from 'images/icons/medium-value-sign.svg';
import LowValueSign from 'images/icons/low-value-sign.svg';
import FactCheck from 'images/icons/fact-check.svg';
import DollarSign from 'images/icons/paid_48dp.svg';
import Phone from 'images/icons/phone_in_talk_48dp.svg';
import Circle from 'images/icons/circle_48dp.svg';
import TouchTunesBlack from 'images/icons/tt_black.svg';
import TouchTunesBlue from 'images/icons/tt_blue.svg';
import SacemLogo from 'images/sacem-logo.png';
import ImpelCopyrightLogo from 'images/impel-copyright-hub-logo.png';
import Ddex from 'images/DDEX-Logo-CMYK.svg';
import LaptopLogo from 'images/laptop-logo.png';
import LaptopUpload from 'images/laptop-upload.png';
import DownArrow from 'images/icons/down-arrow.png';

export default function loadImage(name) {
    switch (name) {
        case 'circle':
            return Circle;
        case 'dollar-sign':
            return DollarSign;
        case 'phone-in-talk':
            return Phone;
        case 'fact-check.svg':
            return FactCheck;
        case 'tt-black':
            return TouchTunesBlack;
        case 'tt-blue':
            return TouchTunesBlue;
        case 'blokur-logo-whiteandblue.svg':
            return BlokurLogoWhiteAndBlue;
        case 'blokur-logo-whiteandblue-beta.png':
            return BlokurLogoWhiteAndBlueBeta;
        case 'blokur-logo-white.svg':
            return BlokurLogoWhite;
        case 'blokur-logo-black.png':
            return BlokurLogoBlack;
        case 'default-display-picture.png':
            return DefaultDisplayPicture;
        case 'processing.gif':
            return Processing;
        case 'maintenance-logo.svg':
            return MaintenanceLogo;
        case 'high-value-sign.svg':
            return HighValueSign;
        case 'medium-value-sign.svg':
            return MediumValueSign;
        case 'low-value-sign.svg':
            return LowValueSign;
        case 'matching-filter-third.png':
            return MatchingFilterThird;
        case 'performance-filter.png':
            return PerformanceFilter;
        case 'progress-filter.png':
            return ProgressFilter;
        case 'mlc-logo-blue.png':
            return MLCLogoBlue;
        case 'sacem-logo.png':
            return SacemLogo;
        case 'impel-copyright-hub-logo.png':
            return ImpelCopyrightLogo;
        case 'ddex':
            return Ddex;
        case 'laptop-logo':
            return LaptopLogo;
        case 'laptop-upload':
            return LaptopUpload;
        case 'down-arrow':
            return DownArrow;
        default:
            console.error('Cannot load image:', name);
            return '';
    }
}
